const global = window

function decodeHtml(str) {
    if (!str) return ''
    if (typeof str !== 'string') return str
    const txt = document.createElement('textarea')
    txt.innerHTML = str
    return txt.value
}

function escapeHtml(str) {
    if (!str) return ''
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
}

function renderGanttPopup(task) {
    const meta = task.meta || task.data || {}
    const clientName = decodeHtml(task.client || meta.client || '')
    const projectName = decodeHtml(task.project || meta.project || '')
    const taskName = decodeHtml(task.task_name || meta.task || task.name || '')
    const priorityLabel = meta.priority_label || 'Normal'
    const priorityColor = meta.priority_color || '#7d967d'
    const hoursReal = meta.hours_real !== undefined && meta.hours_real !== null ? parseFloat(meta.hours_real).toFixed(1) : null
    const hoursFacture = meta.hours_facture !== undefined && meta.hours_facture !== null ? parseFloat(meta.hours_facture).toFixed(1) : null
    const isOverdue = meta.is_overdue
    const daysOverdue = meta.days_overdue || 0
    const progress = Math.round(task.progress || 0)
    const url = task.url || meta.url || ''

    const startDate = task._start ? (window.moment ? window.moment(task._start).format('DD MMM YYYY') : task.start) : ''
    const endDate = task._end ? (window.moment ? window.moment(task._end).format('DD MMM YYYY') : task.end) : ''
    const durationDays = (task._start && task._end) ? Math.max(1, Math.round((new Date(task._end) - new Date(task._start)) / (1000 * 60 * 60 * 24))) : 0

    let statusBadge = ''
    if (progress >= 100) {
        statusBadge = '<span class="gantt-pop-badge gantt-pop-badge--completed"><span class="icon ico icon-check-circle"></span> Terminé (100%)</span>'
    } else if (isOverdue) {
        statusBadge = `<span class="gantt-pop-badge gantt-pop-badge--danger"><span class="icon ico icon-warning"></span> En retard (${daysOverdue} j)</span>`
    } else {
        statusBadge = `<span class="gantt-pop-badge gantt-pop-badge--progress"><span class="icon ico icon-time"></span> En cours (${progress}%)</span>`
    }

    let hoursHtml = ''
    if (hoursReal !== null && (parseFloat(hoursFacture) > 0 || parseFloat(hoursReal) > 0)) {
        const isExceeded = parseFloat(hoursFacture) > 0 && parseFloat(hoursReal) > parseFloat(hoursFacture)
        hoursHtml = `
            <div class="gantt-pop-stat">
                <span class="gantt-pop-stat-label">Heures réelles / budget :</span>
                <span class="gantt-pop-stat-val ${isExceeded ? 'gantt-pop-val--danger' : ''}">
                    <strong>${hoursReal} h</strong>${parseFloat(hoursFacture) > 0 ? ' / ' + hoursFacture + ' h' : ''}
                </span>
            </div>
        `
    }

    return `
        <div class="gantt-pop-card">
            <div class="gantt-pop-header">
                <div class="gantt-pop-tags">
                    ${clientName ? `<span class="gantt-pop-client"><span class="icon ico icon-${meta.client_icon || 'office'}"></span> ${escapeHtml(clientName)}</span>` : ''}
                    <span class="gantt-pop-priority" style="background:${priorityColor}25; color:${priorityColor}; border-color:${priorityColor}60;">
                        ${escapeHtml(priorityLabel)}
                    </span>
                    ${statusBadge}
                </div>
                ${projectName ? `<div class="gantt-pop-project"><span class="icon ico icon-folder"></span> ${escapeHtml(projectName)}</div>` : ''}
                <div class="gantt-pop-task">${escapeHtml(taskName)}</div>
            </div>
            
            <div class="gantt-pop-body">
                <div class="gantt-pop-progress-wrapper">
                    <div class="gantt-pop-progress-bar">
                        <div class="gantt-pop-progress-fill" style="width: ${progress}%; background: ${task.progress_color || '#3b82f6'};"></div>
                    </div>
                    <span class="gantt-pop-progress-text">${progress}%</span>
                </div>

                <div class="gantt-pop-dates">
                    <div class="gantt-pop-date-item">
                        <span class="gantt-pop-date-label">Début</span>
                        <span class="gantt-pop-date-val">${startDate}</span>
                    </div>
                    <div class="gantt-pop-date-arrow">→</div>
                    <div class="gantt-pop-date-item">
                        <span class="gantt-pop-date-label">Fin planifiée</span>
                        <span class="gantt-pop-date-val ${isOverdue ? 'gantt-pop-val--danger' : ''}">${endDate}</span>
                    </div>
                    <div class="gantt-pop-duration">(${durationDays} j)</div>
                </div>

                ${hoursHtml}
            </div>
            
            ${(task.url || meta.url) ? `
                <div class="gantt-pop-footer">
                    <span class="gantt-pop-action"><span class="icon ico icon-link"></span> Cliquer pour ouvrir le dossier</span>
                </div>
            ` : ''}
        </div>
    `
}

inputs.types.gantt = function (data, name, niceName, type, input, parent, inputWindow) {
    data.update = function (task, change) {
        const dataTask = data.items[task._index]
        if (dataTask && dataTask.api && !data.disabled) {
            const url = dataTask.api[0]
            const method = dataTask.api[1] ? dataTask.api[1] : 'PUT'
            const dataOut = {}
            if (typeof change.start !== 'undefined') {
                const indexStart = dataTask.map.start
                const indexEnd = dataTask.map.end
                dataOut[indexStart] = dateYMD(change.start)
                dataOut[indexEnd] = dateYMD(change.end)
            } else if (typeof change.progress !== 'undefined') {
                const indexProgress = dataTask.map.progress
                dataOut[indexProgress] = change.progress
            }
            callAPI(method, url, dataOut)
        }
    }

    if (data && data.settings) {
        data.settings.on_date_change = function (task, start, end) {
            data.update(task, { start, end })
        }
        data.settings.on_progress_change = function (task, progress) {
            data.update(task, { progress })
        }
        data.settings.popup_trigger = 'mouseover'
        data.settings.custom_popup_html = renderGanttPopup

        if (data.tasks.length > 0) {
            const $wrapper = $('#' + name)
            // Remove previous side panel if re-rendering via AJAX
            $wrapper.find('.gantt-side-panel').remove()

            const gantt = new Gantt('#' + name, data.tasks, data.settings)
            const $container = $wrapper.find('.gantt-container')
            $wrapper.addClass('gantt-view-flex')

            $container.dragNscroll({
                handle: '.grid-header, .grid-row, .date' + ((data.disabled) ? ', .bar-group' : ''),
            })

            // Construction de la colonne de titres fixée à gauche
            const headerHeight = data.settings.header_height || 45
            const rowHeight = (data.settings.bar_height || 24) + (data.settings.padding || 12)

            const $sidePanel = $(`
                <div class="gantt-side-panel">
                    <div class="gantt-side-header" style="height: ${headerHeight}px;">
                        <div class="gantt-side-header-title">Client / Dossier / Tâche</div>
                        <div class="gantt-side-header-stats">Prog.</div>
                    </div>
                    <div class="gantt-side-rows"></div>
                </div>
            `)

            const $sideRows = $sidePanel.find('.gantt-side-rows')
            let lastClient = null
            let lastProject = null

            data.tasks.forEach((task, index) => {
                const meta = task.meta || task.data || {}
                const clientName = decodeHtml(task.client || meta.client || 'Sans client')
                const projectName = decodeHtml(task.project || meta.project || 'Sans dossier')
                const taskName = decodeHtml(task.task_name || meta.task || task.name)
                const isNewClient = clientName !== lastClient
                const isNewProject = isNewClient || projectName !== lastProject
                lastClient = clientName
                lastProject = projectName

                const progress = Math.round(task.progress || 0)
                const isOverdue = meta.is_overdue
                const isCompleted = progress >= 100

                let badgeClass = 'pill--progress'
                if (isCompleted) badgeClass = 'pill--completed'
                else if (isOverdue) badgeClass = 'pill--danger'

                const url = task.url || meta.url || ''

                const $row = $(`
                    <div class="gantt-side-row ${isOverdue ? 'row--overdue' : ''} ${isCompleted ? 'row--completed' : ''}" 
                         data-id="${task.id}" 
                         data-index="${index}"
                         style="height: ${rowHeight}px;"
                         title="${escapeHtml(clientName)} • ${escapeHtml(projectName)} — ${escapeHtml(taskName)}">
                        <div class="gantt-side-row-info">
                            <div class="gantt-row-hierarchy">
                                <span class="gantt-row-client ${isNewClient ? 'is-first' : 'is-repeated'}">
                                    <span class="icon ico icon-${meta.client_icon || 'office'}"></span>
                                    <span class="client-name">${escapeHtml(clientName)}</span>
                                </span>
                                <span class="gantt-row-sep">›</span>
                                <span class="gantt-row-project">${escapeHtml(projectName)}</span>
                                <span class="gantt-row-sep">›</span>
                                ${url ? `<a href="${url}" class="gantt-row-task">${escapeHtml(taskName)}</a>` : `<span class="gantt-row-task">${escapeHtml(taskName)}</span>`}
                            </div>
                        </div>
                        <div class="gantt-side-row-badge">
                            <span class="gantt-prog-pill ${badgeClass}">${progress}%</span>
                        </div>
                    </div>
                `)

                $sideRows.append($row)
            })

            $sidePanel.insertBefore($container)

            // Synchronisation du survol (Hover)
            $sidePanel.on('mouseenter', '.gantt-side-row', function () {
                const taskId = $(this).attr('data-id')
                $(this).addClass('is-hovered')
                const bar = gantt.get_bar(taskId)
                if (bar) {
                    $(bar.group).addClass('active')
                    bar.show_popup()
                }
            })

            $sidePanel.on('mouseleave', '.gantt-side-row', function (e) {
                const taskId = $(this).attr('data-id')
                $(this).removeClass('is-hovered')
                const bar = gantt.get_bar(taskId)
                if (bar) {
                    $(bar.group).removeClass('active')
                }
                if (!$(e.relatedTarget).closest('.popup-wrapper').length) {
                    gantt.hide_popup()
                }
            })

            $wrapper.on('mouseenter', '.bar-wrapper', function () {
                const taskId = $(this).attr('data-id')
                $sidePanel.find(`.gantt-side-row[data-id="${taskId}"]`).addClass('is-hovered')
            })

            $wrapper.on('mouseleave', '.bar-wrapper', function () {
                const taskId = $(this).attr('data-id')
                $sidePanel.find(`.gantt-side-row[data-id="${taskId}"]`).removeClass('is-hovered')
            })

            // Clic pour ouvrir le dossier
            $sidePanel.on('click', '.gantt-side-row', function (e) {
                if ($(e.target).is('a')) return
                const taskId = $(this).attr('data-id')
                const task = data.tasks.find(t => t.id === taskId)
                const url = task ? (task.url || (task.meta && task.meta.url) || (task.data && task.data.url)) : null
                if (url) {
                    window.location.href = url
                }
            })

            $wrapper.on('click', '.bar-wrapper', function () {
                if (gantt.bar_being_dragged) return
                const taskId = $(this).attr('data-id')
                const task = data.tasks.find(t => t.id === taskId)
                const url = task ? (task.url || (task.meta && task.meta.url)) : null
                if (url) {
                    window.location.href = url
                }
            })

            // Synchronisation du défilement vertical
            $container.on('scroll', function () {
                $sideRows.scrollTop($container.scrollTop())
            })
        }
    }
    return data
}
